import { atom, useAtom } from 'jotai';

export const cmdkOpenAtom = atom(false);
export const useCommandPalette = () => useAtom(cmdkOpenAtom);
